// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
let nextInstanceId = 0;
const Lost = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
  const instanceId = React.useState(() => `Lost-${++nextInstanceId}`)[0];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? 16}
      height={size ?? 16}
      fill="none"
      viewBox="0 0 16 16"
      ref={ref}
      {...props}
    >
      <g stroke="currentColor" strokeLinejoin="round" clipPath={`url(#${instanceId}-Lost_a)`}>
        <path d="M8 2v3M14 8h-3M8 14v-3M2 8h3M12.243 3.758 10.12 5.879m2.121 6.364-2.121-2.122m-6.363 2.121 2.121-2.121M3.758 3.758l2.121 2.121" />
      </g>
      <defs>
        <clipPath id={`${instanceId}-Lost_a`}>
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ForwardRef = forwardRef(Lost);
export default ForwardRef;
